export default {
  'Please note, any individual provided in this section will be screened.':
    'Please note, any individual provided in this section will be screened.',
  // Services initial page
  'Select services': 'Select services',
  'Please select how you would like to take payments.': 'Please select how you would like to take payments.',
  'You can select POS, E-Commerce, or both together.': 'You can select POS, E-Commerce, or both together.',
  'However, if you are looking for SoftPOS we can currently only on-board you for this service on its own.':
    'However, if you are looking for SoftPOS we can currently only on-board you for this service on its own.',
  'If you are looking for SoftPOS with POS or E-Commerce, please complete the application and once on-boarded, you can request for additional services.':
    'If you are looking for SoftPOS with POS or E-Commerce, please complete the application and once on-boarded, you can request for additional services.',
  'Please select the product that best suits your business needs.':
    'Please select the product that best suits your business needs.',
  'Setup fee': 'Setup fee',
  'Annual fee': 'Annual fee',
  'Agreement to the above Fees and Charges required': 'Agreement to the above Fees and Charges required',
  'Bank Code': 'Bank Code',
  // Services page
  Services: 'Services',
  'Number of applications': 'Number of applications',
  'Number of devices': 'Number of devices',
  'Read more': 'Read more',
  'Website requirements': 'Website requirements',
  'Website URL': 'Website URL',
  'I need web integration': 'I need web integration',
  'Select plugin': 'Select plugin',
  'Select method': 'Select method',
  'Fees and charges*': 'Fees and charges*',
  'Additional services*': 'Additional services*',
  Free: 'Free',
  'Payment Schemes*': 'Payment Schemes*',
  '*These fees are subject to 5% VAT.': '*These fees are subject to 5% VAT.',
  'Acceptance of Canada and USA cards require extra approval. Are you selling to Canada or USA? Request a call with sales.':
    'Acceptance of Canada and USA cards require extra approval. Are you selling to Canada or USA? Request a call with sales.',
  'Reset to default': 'Reset to default',
  'Default pricing:': 'Default pricing:',
  'Callback is requested': 'Callback is requested',
  'Special pricing applied': 'Special pricing applied',
  'Total for all applications': 'Total for all applications',
  'Total for all terminals': 'Total for all terminals',
  'General configurations': 'General configurations',
  'Request a callback': 'Request a callback',
  'Please enter you message in the field below. We will contact you as soon as possible.':
    'Please enter you message in the field below. We will contact you as soon as possible.',
  'Your message': 'Your message',
  'Contact me': 'Contact me',
  'Company request': 'Company request',
  // Company information step
  'Company Information': 'Company Information',
  'Company license': 'Company License',
  'Please upload the company license photo.': 'Please Upload the Company License Photo.',
  'Passport details:': 'Passport Details:',
  'Emirates ID details:': 'Emirates ID Details:',
  'Document data:': 'Document Data:',
  'Please fill in the details about the company you represent.':
    'Please fill in the details about the company you represent.',
  'Date of establishment': 'Date of Establishment',
  'City of establishment': 'City of Establishment',
  'Company legal type': 'Company Legal Type',

  'Company commercial name': 'Company commercial name',
  'Trade license number': 'Trade License Number',
  'License authority': 'License Authority',
  'Issuing Authority': 'Issuing Authority',
  'License issue date': 'License Issue Date',
  'License expiry date': 'License Expiry Date',
  'Company email': 'Company Email',
  'Tax registration certificate': 'Tax Registration Certificate',
  'Yes, I have a Tax registration certificate.': 'Yes, I have a Tax Registration Certificate.',
  'Please upload the Tax registration certificate photo.': 'Please upload the Tax registration certificate photo.',
  'Tax registration number': 'Tax registration number',
  // Addresses step
  Address: 'Company Address',
  '': '',
  'Head office': 'Head Office',
  'This must be the location where you will take payments and where we can reach you.':
    'This must be the location where you will take payments and where we can reach you.',
  Country: 'Country',
  'Address line': 'Address Line',
  'P.O. Box': 'P.O. Box',
  'Office phone number': 'Office Phone Number',
  'Fax number': 'Fax Number',
  Emirate: 'Emirate',
  'Type of property occupied': 'Type of Property Occupied',
  'Please upload your RERA registration or Lease Agreement Documents.':
    'Please upload your RERA registration or Lease Agreement Documents.',
  'Please upload a photo of outside the outlet.': 'Please Upload a Photo of Outside the Outlet.',
  'Please upload a photo of inside the outlet.': 'Please Upload a Photo of Inside the Outlet.',
  '<strong>Do you have any branches?</strong>': '<strong>Do you have any Branches?</strong>',
  'We are currently only able to on-board one location / branch where you can take payments. However, you can continue with this process and we will be happy to add more locations / branches once you are onboarded.':
    'We are currently only able to on-board one location / branch where you can take payments. However, you can continue with this process and we will be happy to add more locations / branches once you are onboarded.',
  'Alternatively, you can stop the process now and request a member of our team to contact you using the contact us form <1>by link<1/>.':
    'Alternatively, you can stop the process now and request a member of our team to contact you using the contact us form <1>by link<1/>.',
  Rented: 'Rented',
  Owned: 'Owned',
  'Pin location': 'Pin Location',
  'Location pinned': 'Location Pinned',
  Location: 'Location',
  'Please pin your company location on the map.': 'Please pin your company location on the map.',
  Save: 'Save',
  // Authorized Representative step
  'Authorized Signatory': 'Authorized Signatory/Power of Attorney Holder',
  'Please provide the details of at least one person who is an authorised representative of your company.':
    'Please provide the details of at least one person who is an authorised representative of your company.',
  'Some of the fields were pre populated. Feel free to edit this data.':
    'Some of the fields were pre populated. Feel free to edit this data.',
  'Please provide the details of at least one person who is legally authorized representative of your company.':
    'Please provide the details of at least one person who is legally authorized representative of your company.',
  'At least one of these representatives must have the authority and proof to act as an authorised signatory for your company.':
    'At least one of these representatives must have the authority and proof to act as an authorised signatory for your company.',
  'Authorised Representative {{number}}': 'Authorised Representative {{number}}',
  'Authorized Representative cannot be deleted': 'Authorized Representative cannot be deleted',
  'This representative is used as shareholder in "Shareholders" step':
    'This representative is used as shareholder in "Shareholders" step',
  'Remove this representative': 'Remove this representative',
  'Add Authorised representative': 'Add Authorised representative',
  'This person is legally authorized signatory': 'This person is an authorized signatory',
  'Shareholder is a Politically Exposed Person (PEP)': 'Shareholder is a Politically Exposed Person (PEP)',
  'Please upload the <strong>passport main page</strong> photo and provide the details in the fields below.':
    'Please upload copy of <strong>passport main photo page</strong> and complete the details in the fields below.',
  'Please upload the <strong>visa page</strong> photo and provide the details in the fields below.':
    'Please upload copy of the<strong> visa page</strong>  and complete the details in the fields below.',
  Designation: 'Designation',
  'Upload a copy of valid notarized Power of Attorney of authorized signatory':
    'Upload a Copy of Valid Notarized Power of Attorney of Authorized Signatory',
  'Person name is listed as manager on Company license': 'Person name is listed as manager on Company license',
  // Shareholders sole proprietor step
  'No authorized representative found': 'No authorized representative found',
  'Since your Company Type was selected as a sole proprietor, the Shareholders section is disabled. You can go to the next step.':
    'Since your Company Type was selected as a sole proprietor, the Shareholders section is disabled. You can go to the next step.',
  'Ownership share:': 'Ownership Share:',
  'Shares %': 'Shares %',
  // Shareholders multiple step
  'Shareholder Proof Document': 'Shareholder Proof Document',
  'Select the document type': 'Select the Document Type',
  'Memorandum of Association': 'Memorandum of Association',
  'Articles of association': 'Articles of association',
  'Add shareholders': 'Add Shareholders',
  'Please add details of shareholders that are holding 25% or more shares/ownership interest.':
    'Please add details of shareholders that are holding 25% or more shares/ownership interest.',
  'Shareholders are listed in company license': 'Shareholders are listed in company license',
  'Upload a copy of Articles of Association (AOA)/ Memorandum of Association (MOA)':
    'Upload a copy of Articles of Association (AOA)/ Memorandum of Association (MOA)',
  'Individual shareholders': 'Individual Shareholders',
  'Legal entity shareholders': 'Legal Entity Shareholders',
  'First name': 'First Name',
  'Last name': 'Last Name',
  'Full name': 'Full Name',
  'Commercial name': 'Commercial Name',
  'Business line': 'Business Line',
  'Company name': 'Company Name',
  Passport: 'Passport',
  'Emirates ID': 'Emirates ID',
  'Edit Individual shareholder': 'Edit Individual Shareholder',
  'Add new Individual shareholder': 'Add New Individual Shareholder',
  'Personal details': 'Personal Details',
  'Personal details of the Authorized Signatory': 'Personal Details of the Authorized Signatory',
  'Date of birth': 'Date of Birth',
  Nationality: 'Nationality',
  License: 'License',
  'Document number': 'Document Number',
  'Passport expiry date': 'Passport Expiry Date',
  'Visa expiry date': 'Visa Expiry Date',
  'Please upload <strong>front side</strong> and <strong>back side</strong> Emirates ID photos.':
    'Please upload <strong>front side</strong> and <strong>back side</strong> Emirates ID photos.',
  'Emirates ID number': 'Emirates ID Number',
  'Emirates ID expiry date': 'Emirates ID Expiry Date',
  'UAE residency & contact details': 'UAE Residency & Contact Details',
  City: 'City',
  Shares: 'Shares',
  'Legal name': 'Legal Name',
  'Country of incorporation': 'Country Of Incorporation',
  'Add Legal entity shareholder': 'Add Legal Entity Shareholder',
  'Please share basic details about the company.': 'Please Share Basic Details about the Company.',
  'Company legal name': 'Company Legal Name',
  'Edit Legal Entity shareholder': 'Edit Legal Entity Shareholder',
  'Beneficial owners': 'Beneficial Owners',
  'Because shares are held by a Legal entity as disclosed in the above section, please provide the details of Beneficial owners of the entity.':
    'Because shares are held by a Legal entity as disclosed in the above section, please provide the details of Beneficial owners of the entity.',
  'Add beneficial owner': 'Add Beneficial Owner',
  'Select authorised representative as a shareholder': 'Select Authorised Representative as a Shareholder',
  'Please select person from the list of shareholders to pre populate the data or fill the form to add new person.':
    'Please select person from the list of shareholders to pre populate the data or fill the form to add new person.',
  'Please specify ownership share': 'Please Specify Ownership Share',
  'Please specify ownership share for this person': 'Please specify ownership share for this person',
  'Additional information': 'Additional Information',
  'In case of complex ownership structure please provide comments and/or schemas that might be relevant.':
    'In case of complex ownership structure please provide comments and/or schemas that might be relevant.',
  'Enter your comments': 'Enter Your Comments',
  'Edit beneficial owner': 'Edit Beneficial Owner',
  'Authorised Signatory Details': 'Authorised Signatory Details',
  // Questionnaire step
  'Additional Information': 'Additional Information',
  'Company Questionnaire': 'Company Questionnaire',
  'Please share additional information about your business.':
    'Please share additional information about your business.',

  Declaration: 'Declaration',
  'Please provide additional information about your business.':
    'Please provide additional information about your business.',
  'Annual turnover / expected annual turnover': 'Annual turnover / expected annual turnover',
  'Do you hold any position from the below list of categories?':
    'Do you hold any position from the below list of categories?',
  'Primary location': 'Primary location',
  Industry: 'Industry',
  'Trade area': 'Trade area',
  'Years in business': 'Years in business',
  'Number of employees': 'Number of employees',
  'Market share, %': 'Market share, %',
  'Expected e-commerce turnover': 'Expected e-commerce turnover',
  'Expected card sales': 'Expected card sales',
  'Total value in AED of expected card and digital payments':
    'Total value in AED of expected card and digital payments',
  '1st year': '1st year',
  '2nd year': '2nd year',
  'Expected non-card sales': 'Expected non-card sales',
  'Total value in AED of non card and digital transactions (e.g. cash and cheque)':
    'Total value in AED of non card and digital transactions (e.g. cash and cheque)',
  'Total expected sales': 'Total expected sales',
  'This is the total value in AED of card and non card sales':
    'This is the total value in AED of card and non card sales',
  'Total expected turnover after two years: <1></1>': 'Total expected turnover after two years: <1></1>',
  'A natural person who is or has been entrusted with prominent public functions including:':
    'A natural person who is or has been entrusted with prominent public functions including:',
  'a head of state, head of government, minister or deputy or assistant minister;':
    'a head of state, head of government, minister or deputy or assistant minister;',
  'a senior government official;': 'a senior government official;',
  'a member of parliament;': 'a member of parliament;',
  'a senior politician;': 'a senior politician;',
  'an important political party official;': 'an important political party official;',
  'a senior judicial official;': 'a senior judicial official;',
  'a member of a court of auditors or the board of a central bank;':
    'a member of a court of auditors or the board of a central bank;',
  'an ambassador, charge d’affaires or other high-ranking officer in a diplomatic service;':
    'an ambassador, charge d’affaires or other high-ranking officer in a diplomatic service;',
  'a high-ranking officer in an armed force;': 'a high-ranking officer in an armed force;',
  'a senior member of an administrative, management or supervisory body of a state-owned enterprise;':
    'a senior member of an administrative, management or supervisory body of a state-owned enterprise;',
  'Any of the following family members of the above, including:':
    'Any of the following family members of the above, including:',
  'a spouse;': 'a spouse;',
  'a partner considered by national law as equivalent to a spouse;':
    'a partner considered by national law as equivalent to a spouse;',
  'a child': 'a child',
  Yes: 'Yes',
  No: 'No',
  'Indicate at least one <1>Authorized Representative</1> or <3>Individual Shareholder</3> as a PEP person.':
    'Indicate at least one <1>Authorized Representative</1> or <3>Individual Shareholder</3> as a PEP person.',
  'Does your company have any direct/indirect dealings involving a Sanctioned Country* or any Sanctioned Party**?':
    'Does your company have any direct/indirect dealings involving a Sanctioned Country* or any Sanctioned Party**?',
  'Is your company owned by any person/entity that is incorporated/based in, or resident in a Sanctioned Country/Territory?':
    'Is your company owned by any person/entity that is incorporated/based in, or resident in a Sanctioned Country/Territory?',
  'Does your business have any offices, investment activities or planned activities in any sanctioned country or have an ownership interest in a Sanctioned Party?':
    'Does your business have any offices, investment activities or planned activities in any sanctioned country or have an ownership interest in a Sanctioned Party?',
  '*Sanctioned Countries - Iran, Syria, Cuba, North Korea/Territory (Crimea) and any other countries/territories as updated time to time by the relevant authorities.':
    '*Sanctioned Countries - Iran, Syria, Cuba, North Korea/Territory (Crimea) and any other countries/territories as updated time to time by the relevant authorities.',
  '**A sanctioned party includes any person or entity designated for sanction reasons by United Nations Security council, The European Union, The Office of Foreign Assets Control (OFAC), UK HMT and Central Bank of UAE Blacklist.':
    '**A sanctioned party includes any person or entity designated for sanction reasons by United Nations Security council, The European Union, The Office of Foreign Assets Control (OFAC), UK HMT and The Central Bank of UAE Blacklist.',
  'Specify the name of the Sanctioned Countries/Territories:':
    'Specify the name of the Sanctioned Countries/Territories:',
  'Enter text here': 'Enter text here',
  'Brief description of business activities conducted in the Sanctioned Countries/Territories:':
    'Brief description of business activities conducted in the Sanctioned Countries/Territories:',
  'What goods/products are involved, what they are used for, the country of origin and destination?':
    'What goods/products are involved, what they are used for, the country of origin and destination?',
  'Going forward, would you expect the dealings with Sanctioned Countries/Territories to increase/decrease/remain the same?':
    'Going forward, would you expect the dealings with Sanctioned Countries/Territories to increase/decrease/remain the same?',
  // Bank account step
  'Bank accounts': 'Bank accounts',
  'Account for devices': 'Account for devices',
  'Bank account details (for credit/debit of sales proceeds)':
    'Bank account details (for credit/debit of sales proceeds)',
  'Please upload scan of bank statement with IBAN number.': 'Please upload scan of bank statement with IBAN number.',
  'Bank name': 'Bank name',
  'Account title': 'Account title',
  'Account title has to be same as on bank statement.': 'Account title has to be same as on bank statement.',
  'Account number': 'Account number',
  'Account for E-commerce': 'Account for E-commerce',
  'Use the same account': 'Use the same account',
  // Review & Confirm step
  'Review & Confirm': 'Review and Submit',
  'Please select each tab to review the information before submitting the application.':
    'Please select each tab to review the information before submitting the application.',
  'To make changes, go to the appropriate section.': 'To make changes, go to the appropriate section.',
  'Company details': 'Company Details',
  Representatives: 'Representatives',
  Shareholders: 'Shareholders',
  'Business nature': 'Business Nature',
  Email: 'Email',
  'Phone number': 'Phone Number',
  'Device account IBAN': 'Device account IBAN',
  'E-Commerce account IBAN': 'E-Commerce account IBAN',
  Residency: 'Residency',
  'Submitting application': 'Submitting application',
  'Please make sure that you verified the information in the tabs. You will not be able to change the application data after submitting.':
    'Please make sure that you verified the information in the tabs. You will not be able to change the application data after submitting.',
  'Do you want to continue?': 'Do you want to continue?',
  'Correct application data': 'Correct application data',
  'Complete all steps to submit application': 'Complete all steps to submit application',
  'Confirm and continue': 'Confirm and continue',
  'Share documents using UAE PASS': 'Share documents using UAE PASS',
  'Continue with UAE PASS': 'Continue with UAE PASS',
  'Since you are authorized representative of this company and login through UAE PASS, your data will be prepopulated from UAE PASS instead of filling this form. Please give consent for sharing the following documents:':
    'Since you are authorized representative of this company and login through UAE PASS, your data will be prepopulated from UAE PASS instead of filling this form. Please give consent for sharing the following documents:',
  Visa: 'Visa',
  'Passport, Emirates ID, POA (optional)': 'Passport, Emirates ID, POA (optional)',
  'Additionally if you need to add POA as a signatory proof, you can add it to your UAE PASS app by requesting from Ministry of Justice department':
    'Additionally if you need to add POA as a signatory proof, you can add it to your UAE PASS app by requesting from Ministry of Justice department',
  'Import UAE PASS': 'Import UAE PASS',
  'Documents received from UAE PASS': 'Documents received from UAE PASS',
  'You have rejected the data sharing request on UAE PASS. Please retry':
    'You have rejected the data sharing request on UAE PASS. Please retry',
  'Please upgrade your account following instructions in the UAE PASS application':
    'Please upgrade your account following instructions in the UAE PASS application',
  'There was an error while fetching your documents from UAE PASS. Please retry':
    'There was an error while fetching your documents from UAE PASS. Please retry',
  "We couldn't receive your information from UAE PASS. Please retry":
    "We couldn't receive your information from UAE PASS. Please retry",
  'We are fetching information from the UAE PASS. Use your UAE PASS application to allow document sharing.':
    'We are fetching information from the UAE PASS. Use your UAE PASS application to allow document sharing.',
  'An existing UAE PASS document sharing request is pending. Please approve this request via your UAE PASS application to proceed.':
    'An existing UAE PASS document sharing request is pending. Please approve this request via your UAE PASS application to proceed.',
  'Invitation sent': 'Invitation sent',
  'Send invitation': 'Send invitation',
};
